import { useMemo } from 'react'

import { useCurrentUserLanguage } from '../../account/hooks/useCurrentUserLanguage'
import { TrackedGame } from '../types/TrackedGame'

type UseLiveEventArchetypeNameParams = {
  archetypeId: string | undefined
  trackedGame: TrackedGame | undefined
}

/**
 * Hook to fetch live event archetype name by ID
 * @param archetypeId - The ID of the archetype to fetch*
 * @param trackedGameId - The ID of the tracked game to fetch
 * @returns Object containing archetype name, loading state, and error state
 */
export const useLiveEventArchetypeName = ({ archetypeId, trackedGame }: UseLiveEventArchetypeNameParams) => {
  const userLanguage = useCurrentUserLanguage()

  const archetypeName = useMemo(() => {
    if (!trackedGame?.archetypes || !archetypeId) {
      return undefined
    }

    // Try to get the name in the user's language, fallback to English, then any available language
    return (
      trackedGame.archetypes.find((archetype) => archetype.archetypeId === archetypeId)?.names[userLanguage] ||
      trackedGame.archetypes.find((archetype) => archetype.archetypeId === archetypeId)?.names['en'] ||
      undefined
    )
  }, [trackedGame, userLanguage, archetypeId])

  return archetypeName
}

export const useLiveEventArchetypeDiscontinued = ({ archetypeId, trackedGame }: UseLiveEventArchetypeNameParams) => {
  return trackedGame?.archetypes?.find((archetype) => archetype.archetypeId === archetypeId)?.discontinued
}
